import { render } from "./UserInfoModal.vue?vue&type=template&id=18efbdd2&scoped=true"
import script from "./UserInfoModal.vue?vue&type=script&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&lang=js"

import "./UserInfoModal.vue?vue&type=style&index=0&id=18efbdd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18efbdd2"]])

export default __exports__